import { CSSProperties, forwardRef, PropsWithChildren } from "react";
import { InputWrapper, SuffixWrapper } from "./styles";
// Should we separate inputs to string and number types?
// Reckon this would be better for different use cases
export interface IInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  suffix?: JSX.Element;
  placeholder?: string;
  type?: string;
  leftAccessory?: JSX.Element;
  rightAccessory?: JSX.Element;
  wrapperStyles?: CSSProperties;
  inputStyles?: CSSProperties;
  error?: boolean;
}

export const Input = forwardRef<any, PropsWithChildren<IInputProps>>((
  {
    suffix,
    placeholder,
    // Text, not number: `type="number"` brings the spinner, the scroll-wheel
    // nudge and a locale-dependent parse to fields that are money. A numeric
    // field passes `inputMode="decimal"` for the keypad; a search box does not.
    type = "text",
    leftAccessory,
    rightAccessory,
    error,
    wrapperStyles,
    inputStyles,
    ...others
  },
  ref,
) => (
  <InputWrapper error={error} style={wrapperStyles}>
    {leftAccessory}
    <input
      // Only meaningful on a number input, which this no longer is by default.
      step={type === "number" ? "any" : undefined}
      placeholder={placeholder}
      type={type}
      {...others}
      ref={ref}
      autoComplete="off"
      onWheel={(e) => e.currentTarget.blur()}
      style={{ outline: "none", ...inputStyles }}
    />
    <SuffixWrapper>{suffix}</SuffixWrapper>
    {rightAccessory}
  </InputWrapper>
));
